import React, { PropTypes } from 'react'

PageHeader.propTypes = {
  title: PropTypes.string.isRequired
}

PageHeader.defaultProps = {
  title: ""
}

const styles = {
  container: {
    fontFamily: 'Montserrat',
    padding: '2rem 0',
    background: '#f1f1f1',
    borderBottom: '1px solid #eceeef',
    marginBottom:'15px'
  },
  heading: {
    textTransform: 'uppercase',
    marginTop: '0px',
    marginBottom: '0px',
    letterSpacing: '0.07em',
    fontSize: '16px'
  }
}

export default function PageHeader ({ title }) {
  return (
    <div style={styles.container}>
      <div className="container">
        <h2 style={styles.heading}>{ title }</h2>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/app/components/page-header.js